export const isPWA = () => typeof window !== "undefined" && "strapiUser" in window;

const safeAreaInsetTopCssValue = "var(--safe-area-inset-top, env(safe-area-inset-top, 0px))";

export const isAndroid = () => {
  if (typeof navigator === "undefined") return false;
  return /Android/i.test(navigator.userAgent || "");
};

export const isAndroidWebView = () => {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  const isWv = /\bwv\b/.test(ua) || /; wv\)/.test(ua);
  const isLegacyWebView = /Version\/\d+\.\d+/.test(ua) && /Chrome\/\d+/.test(ua);
  return isAndroid() && (isWv || isLegacyWebView);
};

export const getAndroidStatusBarHeight = () => {
  if (typeof window === "undefined") return 0;
  if (!isAndroidWebView()) return 0;
  const screenHeight = window.screen?.height;
  const innerHeight = window.innerHeight;
  const diff = typeof screenHeight === "number" ? screenHeight - innerHeight : 0;
  if (Number.isFinite(diff) && diff > 0 && diff < 80) return diff;
  return 24;
};

export const getAndroidSafeAreaTopPaddingCss = (basePx = 0) => {
  if (typeof window === "undefined") return `${basePx}px`;
  if (!isAndroidWebView()) return `${basePx}px`;
  return getSafeAreaTopPaddingCss(basePx);
};

export const getSafeAreaTopPaddingCss = (basePx = 0) =>
  `calc(${basePx}px + ${safeAreaInsetTopCssValue})`;
